import { NgModule } from '@angular/core';

import { ClickEditComponent } from "./clickEditModal.component";
import { ModalComponent } from "./modal.component";
import { ArrayEditComponent } from "./arrayEditor.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CardModule } from "../ui_card/card.module";
import { ClickOutsideModule } from "../ui_clickOutside/clickOutside.module";
import { FocusIfModule } from 'libraries/ui_toolbox/focus-if.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {IconNameToDefinitionModule} from "../pipes/icon-name-to-definition/icon-name-to-definition.module";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
    imports: [
        CommonModule,
        FocusIfModule,
        FormsModule,
        CardModule,
        ClickOutsideModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
        PermissionModule,
    ],
    exports: [
        ClickEditComponent,
        ModalComponent,
        ArrayEditComponent
    ],
    entryComponents: [
        ClickEditComponent,
        ModalComponent,
        ArrayEditComponent
    ],
    declarations: [
        ClickEditComponent,
        ModalComponent,
        ArrayEditComponent
    ],
    providers: [],
})
export class ModalModule {
}
